import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';

import CustomEditor from 'components/base/CustomEditor';
import {
  ReactHookFormErrorMessage,
  hasError,
} from 'components/base/ErrorFieldMessage';
import { CustomTitleLabel } from 'components/earning/CustomBaseComponments';
import { CustomTitleWithDropDown } from 'components/customer/CustomTitleWithDropDown';
import { TRANSACTION_RECORD_TYPE } from 'containers/record/records/TransactionList';
import { POINT_RECORD_TYPE } from 'config/CustomEnums';

import { createAction } from 'utils';

function CreatePointRecordDetail({ allTransactionList }) {
  const dispatch = useDispatch();
  const { watch, setValue, formState } = useFormContext();
  const { errors } = formState;
  const selectedCustomerField = 'customer';
  const pointTypeField = 'pointType';
  const pointsField = 'points';
  const tpeField = 'tpe';
  const transactionField = 'transaction';
  const remarksField = 'remarks';
  const pointsTpeField = 'pointsTpe'
  const selectedCustomer = watch(selectedCustomerField);
  const type = watch(pointTypeField);
  const points = watch(pointsField);
  const tpe = watch(tpeField);
  const transaction = watch(transactionField);
  const remarks = watch(remarksField);

  const [transactionRefreshDate, setTransactionRefreshDate] = useState(
    new Date(),
  );
  const [lastTransactionRefreshDate, setLastTransactionRefreshDate] = useState(
    transactionRefreshDate,
  );

  const sectionTitle = (type) => {
    if (type === POINT_RECORD_TYPE.TYPE_ADD) {
      return 'ADD POINT';
    }
    if (type === POINT_RECORD_TYPE.TYPE_REMOVE) {
      return 'REMOVE POINT';
    }
  };

  useEffect(() => {
    if (selectedCustomer?.ssoUid) {
      dispatch(
        createAction('transactions/updateState')({ allTransactionList: [] }),
      );
      setLastTransactionRefreshDate(new Date())
      // dispatch(
      //   createAction('transactions/getCurrentPageTransactions')({
      //     isSelectorLoad: true,
      //     ssoUid: selectedCustomer?.ssoUid,
      //     rank: true,
      //   }),
      // );
    }
  }, [selectedCustomer]);

  return (
    <>
      <div className="first-section-title">{sectionTitle(type)}</div>
      <div>
        <CustomTitleLabel title="Value" />
        <div className="d-flex">
          <input
            type="text"
            className={`day-input-fields ${
              hasError(errors, pointsTpeField) || hasError(errors, pointsField) ? 'error-field' : ''
            }`}
            value={points}
            onInput={(e) => {
              let data = e.target.value;
              data = data.replace(/[^0-9.]/g, '');
              setValue(pointsField, data, { shouldDirty: true });
            }}
          />
          <label className="days-label">points</label>
        </div>
        <ReactHookFormErrorMessage errors={errors} id={pointsField} />
        <CustomTitleLabel title="Progression Points Value" />
        <div className="d-flex">
          <input
            type="text"
            className={`day-input-fields ${
              hasError(errors, pointsTpeField) || hasError(errors, tpeField) ? 'error-field' : ''
            }`}
            value={tpe}
            onInput={(e) => {
              let data = e.target.value;
              data = data.replace(/[^0-9.]/g, '');
              setValue(tpeField, data, { shouldDirty: true });
            }}
          />
          <label className="days-label">progression points</label>
        </div>
        <ReactHookFormErrorMessage errors={errors} id={tpeField} />
        <ReactHookFormErrorMessage errors={errors} id={pointsTpeField} />
      </div>
      {/* {isEdit ? editDetailExtraSection(type) : null} */}
      <CustomTitleWithDropDown
        // customClass={'filter-title'}
        title={'Related transaction (optional)'}
        source={allTransactionList}
        placeholder={'Search by Transaction ID,  Invoice ID'}
        labelContainPk
        defaultValue={transaction}
        setValue={(v) => {
          setValue(transactionField, v, { shouldDirty: true });
        }}
        loadMoreAction={'transactions/getCurrentPageTransactions'}
        // customFilter={customFilter}
        filterAction={'transactions/getCurrentPageTransactions'}
        defaultFilter={{
          isSelectorLoad: true,
          ssoUid: selectedCustomer?.ssoUid,
          rank: true,
          searchField: 'searchIdOrInvoiceId',
        }}
        customItem={(item) => {
          return `Transaction ID: ${item.pk}`;
        }}
        showItemDescription
        customItemDescription={(item) => {
          return `Invoice ID: ${
            (item.transactionDisplayType ===
            TRANSACTION_RECORD_TYPE.TYPE_OFFLINE_POS
              ? item.posInvoiceId
              : item.invoiceId) || '-'
          }`;
        }}
        isReset={lastTransactionRefreshDate !== transactionRefreshDate}
        resetChange={() => {
          setLastTransactionRefreshDate(transactionRefreshDate);
        }}
      />
      <div>
        <CustomTitleLabel title="Remarks (optional)" />
        <CustomEditor
          initialValue={remarks}
          onValueChange={(data) => {
            setValue(remarksField, data, { shouldDirty: true });
          }}
        />
      </div>
    </>
  );
}

const mapPropsToState = (state) => ({
  expiryDate: state.createPointRecord.pointRecord.expiryDate,
  usedDate: state.createPointRecord.pointRecord.usedDate,
  allTransactionList: state.transactions.allTransactionList,
});

export default connect(mapPropsToState)(CreatePointRecordDetail);
